import { backdropClasses, Button, FormControl, Grid, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { useEffect, useState } from "react";
import { Backend } from "../../services/Backend";
import dayjs from "dayjs";
import { SuccessToast, userHasPermissions } from "../../utils/utils";
import { UserPermissions } from "../../dto/Permissions";

export default function PersonalInfoPage(){
    const [error, setError] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [interest, setInterest] = useState("");
    const [language, setLanguage] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [dateOfBirth, setDateOfBirth] = useState(null);
    const [functionTitle, setFunctionTitle] = useState("");
    const [address, setAddress] = useState("");
    const [state, setState] = useState("");
    const [country, setCountry] = useState("");
    const [zipcode, setZipcode] = useState("");
    const [mailingFrequency, setMailingFrequency] = useState("");

    const [originData, setOriginData] = useState({});
    
    const [userCanChangeMailFrequency, setUserCanChangeMailFrequency] = useState(false);

    useEffect(() => {
        Backend.get(`user/me`)
            .then(res => {
                setFirstName(res.firstName);
                setLastName(res.lastName);
                setEmail(res.email);
                setInterest(res.interest);
                setLanguage(res.language);
                setCompanyName(res.companyName);
                setDateOfBirth(dayjs(res.dateOfBirth));
                setFunctionTitle(res.function);
                setAddress(res.address);
                setState(res.state);
                setCountry(res.country);
                setZipcode(res.zipcode);
                setMailingFrequency(res.mailingFrequency);

                setOriginData(res);
            });

        userHasPermissions(UserPermissions.ChangeMailingFrequency)
            .then(res => setUserCanChangeMailFrequency(res));
    },[]);

    const onSave = () => {
        const body = prepareBody();

        Backend.put("user/me", body)
            .then(res => SuccessToast("Data updated!"));
    }

    const prepareBody = () => {
        const body = {};
        
        if (firstName !== originData.firstName) body.firstName = firstName;
        if (lastName !== originData.lastName) body.lastName = lastName;
        if (email !== originData.email) body.email = email;
        if (password !== "") body.password = password;
        if (interest !== originData.interest) body.interest = interest;
        if (language !== originData.language) body.language = language;
        if (companyName !== originData.companyName) body.companyName = companyName;
        if (dateOfBirth !== originData.dateOfBirth) body.dateOfBirth = dateOfBirth;
        if (functionTitle !== originData.function) body.function = functionTitle;
        if (address !== originData.address) body.address = address;
        if (state !== originData.state) body.state = state;
        if (country !== originData.country) body.country = country;
        if (zipcode !== originData.zipcode) body.zipcode = zipcode;
        if (userCanChangeMailFrequency && mailingFrequency !== originData.mailingFrequency) body.mailingFrequency = mailingFrequency;
        
        return body;
    }

    return <div>
        <Grid container spacing={2}>
            <Grid item xs={6}>
                <TextField margin="normal" required fullWidth label="First name" value={firstName} onChange={(e) => setFirstName(e.target.value)} /> 
            </Grid>
            <Grid item xs={6}>
                <TextField margin="normal" required fullWidth label="Last name" value={lastName} onChange={(e) => setLastName(e.target.value)} /> 
            </Grid>
            <Grid item xs={6}>
                <TextField margin="normal" required fullWidth label="Email" value={email} onChange={(e) => setEmail(e.target.value)} /> 
            </Grid>
            <Grid item xs={6}>
                <TextField margin="normal" type="password" required fullWidth label="Password" value={password} onChange={(e) => setPassword(e.target.value)} /> 
            </Grid>
            <Grid item xs={6}>
                <FormControl fullWidth  margin="normal">
                    <InputLabel>Interest</InputLabel>
                    <Select
                        label="Interest"
                        margin="normal"
                        value={interest}
                        onChange={(e) => setInterest(e.target.value)}
                    >
                        <MenuItem value="Transport safety">Transport safety</MenuItem>
                        <MenuItem value="Industrial safety">Industrial safety</MenuItem>
                        <MenuItem value="Chemical warehousing">Chemical warehousing</MenuItem>
                        <MenuItem value="Tank storage">Tank storage</MenuItem>
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={6}>
            <FormControl fullWidth margin="normal">
                    <InputLabel>Language</InputLabel>
                    <Select
                        label="Language"
                        margin="normal"
                        value={language}
                        onChange={(e) => setLanguage(e.target.value)}
                    >
                        <MenuItem value="English">English</MenuItem>
                        <MenuItem value="Dutch">Dutch</MenuItem>
                        <MenuItem value="German">German</MenuItem>
                        <MenuItem value="Spanish">Spanish</MenuItem>
                        <MenuItem value="French">French</MenuItem>
                        <MenuItem value="Chinese">Chinese</MenuItem>
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={6}>
                <TextField margin="normal" required fullWidth label="Company name" className="mb-[20px]" value={companyName} onChange={(e) => setCompanyName(e.target.value)} /> 
            </Grid>
            <Grid item xs={6}>
                <DatePicker sx={{ mt: 2, mb: 1 }}  slotProps={{ textField: { fullWidth: true } }} margin="normal" required fullWidth label="Date of birth" value={dateOfBirth} onChange={(date) => setDateOfBirth(date)} /> 
            </Grid>
            <Grid item xs={6}>
                <TextField margin="normal" required fullWidth label="Function" value={functionTitle} onChange={(e) => setFunctionTitle(e.target.value)} /> 
            </Grid>
            <Grid item xs={6}>
                <TextField margin="normal" required fullWidth label="Address" value={address} onChange={(e) => setAddress(e.target.value)} /> 
            </Grid>
            <Grid item xs={6}>
                <TextField margin="normal" required fullWidth label="State" value={state} onChange={(e) => setState(e.target.value)} /> 
            </Grid>
            <Grid item xs={6}>
                <TextField margin="normal" required fullWidth label="Country" value={country} onChange={(e) => setCountry(e.target.value)} /> 
            </Grid>
            <Grid item xs={6}>
                <TextField margin="normal" required fullWidth label="Zipcode" value={zipcode} onChange={(e) => setZipcode(e.target.value)} /> 
            </Grid>
            { userCanChangeMailFrequency && <>
                <Grid item xs={6}>
                    <FormControl fullWidth margin="normal">
                        <InputLabel>Mail frequency</InputLabel>
                        <Select
                            label="Mail frequency"
                            margin="normal"
                            value={mailingFrequency}
                            onChange={(e) => setMailingFrequency(e.target.value)}
                            >
                            <MenuItem value="Weekly">Weekly</MenuItem>
                            <MenuItem value="Monthly">Monthly</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
            </>}
        </Grid>
        <Button
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            onClick={onSave}
        >
        Save
        </Button>
    </div>
}